module.exports = __webpack_public_path__ + "media/promo/courses/images/f2-f0d67f3b07575c2858936467d7799ae3.svg";